<template>
  <div id="home" class="home">
    <section class="hero glass">
      <div class="hero-text">
        <span class="hero-tag">성덕컴퓨터</span>
        <h1>
          놀라운 경험과 해결책을 만드는
          <span>기술 파트너</span>
        </h1>
        <p>
          숙련된 노하우로 고객 환경에 맞는 맞춤형 해결책을 제시하고,
          더 편리하고 안정적인 운영 환경을 설계합니다.
        </p>
        <div class="hero-actions">
          <a href="#contact" class="btn-primary">견적 문의</a>
          <a href="#portfolio" class="btn-secondary">주요 사업 보기</a>
        </div>
      </div>
      <div class="hero-panel">
        <div class="hero-card">
          <h3>실행 가능한 설계</h3>
          <p>현장 조건을 반영한 네트워크, 서버, 업무 시스템 구축</p>
        </div>
        <div class="hero-card accent">
          <h3>빠른 대응</h3>
          <p>장애 대응, 확장, 운영에 필요한 즉시 지원 체계</p>
        </div>
      </div>
    </section>

    <section id="portfolio" class="section">
      <header class="section-header">
        <h2>주요 사업</h2>
        <p>핵심 역량을 중심으로 확장 가능한 솔루션을 제공합니다.</p>
      </header>
      <div class="service-grid">
        <article
          v-for="item in portfolioItems.slice(0, 4)"
          :key="item.id"
          class="service-card"
        >
          <img :src="item.image" :alt="item.title" />
          <div class="service-body">
            <h3>{{ item.title }}</h3>
            <p>운영 효율과 안정성을 함께 고려한 설계를 제공합니다.</p>
          </div>
        </article>
      </div>
    </section>

    <section id="about" class="section about">
      <header class="section-header">
        <h2>About Us</h2>
        <p>2024년 안산 선부동에서 시작한 현장 중심의 기술 서비스.</p>
      </header>
      <div class="about-grid">
        <div>
          <h3>경험 기반 실행력</h3>
          <p>
            시스템 구축과 운영 경험을 바탕으로 실제 환경에 맞는 솔루션을
            설계합니다.
          </p>
        </div>
        <div>
          <h3>함께 성장하는 파트너십</h3>
          <p>
            고객의 운영 흐름을 이해하고 장기적인 관계로 함께 성장합니다.
          </p>
        </div>
      </div>
    </section>

    <section id="contact" class="section contact">
      <header class="section-header">
        <h2>Contact</h2>
        <p>필요한 내용을 알려주시면 빠르게 안내드리겠습니다.</p>
      </header>
      <form class="contact-form" @submit.prevent="submitForm">
        <input type="text" v-model="form.name" placeholder="Name" />
        <input type="text" v-model="form.email" placeholder="Email" />
        <textarea v-model="form.message" placeholder="Message"></textarea>
        <button type="submit" class="btn-primary">Send Message</button>
      </form>
    </section>
  </div>
</template>

<script>
import pic01 from "@/assets/images/pic01.jpg";
import pic02 from "@/assets/images/pic02.jpg";
import pic03 from "@/assets/images/pic03.jpg";
import pic04 from "@/assets/images/pic04.jpg";

export default {
  name: "HomeComponent",
  components: {},

  data() {
    return {
      portfolioItems: [
        { id: 1, title: "네트워크 구축", image: pic01 },
        { id: 2, title: "서버 구축", image: pic02 },
        { id: 3, title: "웹 어플리케이션", image: pic03 },
        { id: 4, title: "휴대폰 어플리케이션", image: pic04 },
        // { id: 5, title: '컴퓨터 프로그램', image: pic05 },
      ],
      form: {
        name: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    submitForm() {
      alert(
        `Name: ${this.form.name}\nEmail: ${this.form.email}\nMessage: ${this.form.message}`
      );
      // You can replace the alert with actual form submission logic
    },
  },
};
</script>
<style scoped>
.home {
  display: flex;
  flex-direction: column;
  gap: 56px;
  margin-top: 24px;
}

.hero {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
  padding: 40px;
  border-radius: var(--radius-lg);
  animation: fadeUp 0.6s ease;
}

.hero-text h1 {
  font-size: clamp(2rem, 3.2vw, 3.2rem);
  margin: 12px 0 16px;
  line-height: 1.1;
}

.hero-text h1 span {
  color: var(--accent);
}

.hero-text p {
  color: var(--muted);
  font-size: 1rem;
  line-height: 1.7;
}

.hero-tag {
  display: inline-flex;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(27, 127, 108, 0.12);
  color: var(--accent-strong);
  font-weight: 600;
  font-size: 0.85rem;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.hero-panel {
  display: grid;
  gap: 18px;
}

.hero-card {
  padding: 20px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 12px 24px rgba(31, 42, 36, 0.08);
}

.hero-card.accent {
  background: rgba(27, 127, 108, 0.12);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.section-header h2 {
  font-size: 1.9rem;
  margin: 0 0 8px;
}

.section-header p {
  color: var(--muted);
  margin: 0;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
}

.service-card {
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 1px solid var(--border);
  background: var(--surface);
  box-shadow: 0 12px 24px rgba(31, 42, 36, 0.08);
  transition: transform 0.2s ease;
}

.service-card:hover {
  transform: translateY(-4px);
}

.service-card img {
  height: 180px;
  width: 100%;
  object-fit: cover;
}

.service-body {
  padding: 18px;
}

.service-body p {
  color: var(--muted);
  margin-top: 8px;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  background: rgba(255, 255, 255, 0.7);
  padding: 24px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
}

.contact-form {
  display: grid;
  gap: 16px;
  max-width: 720px;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  font-size: 1rem;
  background: #ffffff;
}

.contact-form textarea {
  min-height: 150px;
  resize: vertical;
}

@media (max-width: 720px) {
  .hero {
    padding: 28px;
  }
}
</style>
